import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import AboutUs from './components/AboutUs';
import FAQ from './components/FAQ';
import Team from './components/Team';
import CallToAction from './components/CallToAction';
import { motion } from 'framer-motion';
import Footer from './components/Footer';
import ContactForm from './components/ContactForm';
import { Routes, Route } from 'react-router-dom';
import Projects from './components/Projects';
import WareHouse from './components/WareHouse';
import Hotels from './components/Hotels';
import Farms from './components/Farms';

function App() {
  return (
    <div className="w-full overflow-x-hidden scroll-smooth">
      <div className="w-full mx-auto fixed top-0 z-50">
        <Header />
      </div>

      <Routes>
        <Route path="/" element={
          <div className="w-full min-h-screen">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <Hero />
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <AboutUs />
              <Team />
              <CallToAction />
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <FAQ />
              <ContactForm />
            </motion.div>
          </div>
        } />
        <Route path="/home" element={<Hero />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/team" element={<Team />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/warehouse" element={<WareHouse />} />
        <Route path="/farms" element={<Farms />} />
        <Route path="/hotel" element={<Hotels />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
